<template>
	<layout-page title="Dashboard">
		<!-- control/filter bar  -->
		<my-contracts-filter
			v-model="filter"
			v-if="showFilter"
			v-on:close="closeFilter()"
			:filter-options="filterOptions"
		/>
		<!-- filter bar -->

		<div class="flex-grow flex flex-col bg-gray-100">
			<!-- header -->
			<div
				class="bg-green px-4 sm:px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
			>
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					{{ __("My Contracts") }}
				</h1>
			</div>

			<div
				class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 flex-wrap flex items-center space-x-4 md:space-x-6"
			>
				<button
					class="relative inline-flex px-2 lg:pr-4 py-1.5 font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg flex items-center focus:ring-2 ring-gray-400"
					v-on:click="showFilter = !showFilter"
				>
					<ui-icon
						class="mr-2 flex-shrink-0 h-5 w-5"
						name="filter"
						stroke-width="2"
					/>
					{{ __("Filter") }}
					<span
						class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-or-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
						v-if="activeFilterCount > 0"
						>{{ activeFilterCount }}</span
					>
				</button>

				<div class="flex items-center space-x-4 text-gray-100">
					<div class="flex items-center">
						<input
							id="nachfrage"
							name="filtertype"
							type="radio"
							v-model="filter.type"
							value="SELL"
							:checked="user.type === 'FARMER' ? true : false"
							class="h-5 w-5 bg-gray-600 border-gray-300 rounded text-orange focus:ring-orange border-gray-200 rounded hover:ring-4 hover:ring-orange-800 cursor-pointer"
						/>
						<label
							for="nachfrage"
							class="pl-3 block font-medium whitespace-nowrap cursor-pointer"
							>{{ __("Sale") }}</label
						>
					</div>
					<div class="flex items-center cursor-pointer">
						<input
							id="angebote"
							name="filtertype"
							type="radio"
							v-model="filter.type"
							value="BUY"
							:checked="user.type !== 'FARMER' ? true : false"
							class="h-5 w-5 bg-gray-600 border-gray-300 rounded text-orange focus:ring-orange hover:ring-4 hover:ring-orange-800 cursor-pointer"
						/>
						<label
							for="angebote"
							class="pl-3 block font-medium whitespace-nowrap cursor-pointer"
							>{{ __("Purchase") }}</label
						>
					</div>
				</div>
			</div>
			<!--content-my-contracts-no-contracts
				v-if="isDummyData"
			></content-my-contracts-no-contracts>

			<content-my-contracts-no-matches
				v-if="filteredContracts.length == 0"
			></content-my-contracts-no-matches-->

			<div class="px-4 sm:px-6 lg:px-6 pt-6 bg-gray-100">
				<div class="py-6 grid grid-cols-2 gap-x-6 gap-y-6">
					<div class="">
						<span v-if="locale == 'en'">
							<h2 class="text-xl sm:text-2xl text-gray-500 font-semibold mb-2">
								Was zeigt Ihnen diese Übersicht?
							</h2>
							<p>
								Das Dashboard "Meine Kontrakte" bietet Ihnen einen schnellen
								Überblick über ihre Handelsaktivitäten hier auf cropspot.
								Außerdem finden Sie hier alle bisher abgeschlossenen Kontrakte
								bequem zum Download.
							</p>
						</span>
						<span v-else>
							<h2 class="text-xl sm:text-2xl text-gray-500 font-semibold mb-2">
								Was zeigt Ihnen diese Übersicht?
							</h2>
							<p>
								Das Dashboard "Meine Kontrakte" bietet Ihnen einen schnellen
								Überblick über ihre Handelsaktivitäten hier auf cropspot.
								Außerdem finden Sie hier alle bisher abgeschlossenen Kontrakte
								bequem zum Download.
							</p>
						</span>
					</div>
					<div class="">
						<span v-if="locale == 'en'">
							<p>
								Behalten Sie Ihre komplette Vermarktung im Blick und binden Sie
								auch externe Kontrakte ein.
							</p>
						</span>
						<span v-else>
							<p>
								Behalten Sie Ihre komplette Vermarktung im Blick und binden Sie
								auch externe Kontrakte ein.
							</p>
						</span>
						<div class="mt-2 text-center">
							<ui-button
								class="flex items-center flex-shrink-0 mx-auto"
								v-on:click="
									$bus.$emit(
										'toggle-iframe-modal',
										$route('external_contract.create')
									)
								"
							>
								<ui-icon
									class="mr-2 -ml-1 flex-shrink-0 h-5 w-5 text-white"
									name="plus"
									stroke-width="2"
								/>
								<span class="">{{ __("External Contract") }}</span>
							</ui-button>
						</div>
					</div>
				</div>

				<div class="py-6 grid grid-cols-2 gap-x-6 gap-y-6 relative z-0">
					<div
						v-if="isDummyData"
						class="contracts-overlay bg-gray-100 opacity-75 absolute inset-0 w-full h-full z-10"
					></div>

					<!-- Kacheln: sobald die serverseitig aggregierten Kennzahlen geladen sind -->
					<div
						v-if="summaryLoading"
						class="col-span-2 py-10 text-center text-gray-500"
					>
						Kennzahlen werden geladen …
					</div>
					<template v-else>
						<div class="contents">
							<my-contracts-summary-tile
								class=""
								:totals="summary.totals"
								:data-by-year="summary.byYear"
								:key="'QTY_summary'"
							/>
							<my-contracts-summary-tile
								class=""
								:totals="summary.totals"
								:data-by-year="summary.byYear"
								:key="'REVENUE_summary'"
								field="revenue"
							/>
						</div>

						<my-contracts-product-grade-tile
							:by-grade-data="summary.byGrade"
							:filterType="filter.type"
							:key="'GRADES_' + summaryVersion"
							class="col-span-2"
						/>
					</template>

					<!-- Liste: sobald die Verträge geladen sind -->
					<div
						v-if="contentLoadingSpinner"
						class="col-span-2 py-10 text-center text-gray-500"
					>
						Verträge werden geladen …
					</div>
					<my-contracts-list
						v-else
						:user="user"
						:contracts="filteredContracts"
						:isDummyData="isDummyData"
						:filterType="filter.type"
						:userLocations="userLocations"
						class="col-span-2"
					/>
				</div>
			</div>

			<ui-modal
				:small="true"
				:title="__('Thank you for your interest!')"
				alert-style="check"
				:confirm-label="__('OK')"
				:hasDismissButton="false"
				v-if="showTestButtonThankYouModal"
				v-on:dismiss="closeThankyouModal()"
				v-on:close="closeThankyouModal()"
			>
				<span v-if="locale == 'en'">
					Thank you for your interest! We inform you as soon as this function is
					available.
				</span>
				<span v-else>
					Gerne informieren wir Sie, sobald auch externe Kontrakte eingebunden
					werden können.
				</span>
			</ui-modal>
		</div>
	</layout-page>
</template>

<script>
import axios from "axios";

export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		testButtonThankYouModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			contracts: [],
			userLocations: [],
			isDummyData: false,
			contentLoadingSpinner: true,
			summary: { totals: { qty: 0, revenue: 0 }, byYear: [], byGrade: [] },
			summaryLoading: true,
			summaryVersion: 0,
			// Sequenz-Token: nur die Antwort des jeweils zuletzt gestarteten Requests anwenden,
			// damit eine spaeter eintreffende, aeltere Antwort nicht den aktuellen Filter ueberschreibt.
			summaryRequestId: 0,
			contentRequestId: 0,
			filter: {
				productGrades: [],
				productYears: [],
				contractSources: [],
				type: this.user.type === "FARMER" ? "SELL" : "BUY",
			},
			showFilter: false,
			showModal: false,
			showTestButtonThankYouModal: this.testButtonThankYouModal,
		};
	},
	created() {
		//?
		if (window.location.hash != "") {
			this.filter.productGrades = [window.location.hash.substr(1)];
		}
	},
	mounted() {
		this.reload();
		this.$bus.$on("content:load", this.reload);
		// Nach dem Schließen des iframe-Modals (externer Vertrag angelegt/bearbeitet) neu laden.
		// ModalContainer feuert "iframe close" auf dem Bus (die iframe-Grenze überquert $bus nicht).
		this.$bus.$on("iframe close", this.reload);
	},
	beforeDestroy() {
		this.$bus.$off("content:load", this.reload);
		this.$bus.$off("iframe close", this.reload);
	},
	watch: {
		// Kacheln werden serverseitig gefiltert → bei Filteränderung Summary neu holen.
		// Die Liste filtert clientseitig (filteredContracts), braucht daher kein Neuladen.
		filter: {
			handler() {
				this.loadSummary();
			},
			deep: true,
		},
	},
	computed: {
		/**
		 * Filter als flaches Objekt für die Summary-Query (wird als Query-Params geschickt,
		 * wie in der Suche: Client-State auslesen → an den Server).
		 */
		filterParams() {
			return {
				type: this.filter.type,
				productGrades: this.filter.productGrades,
				productYears: this.filter.productYears,
				contractSources: this.filter.contractSources,
			};
		},

		/**
		 * Filter-Optionen aus den geladenen Verträgen ableiten (Erntejahre + gehandelte Grades)
		 * — reaktiv, da die Verträge erst asynchron nachgeladen werden.
		 */
		filterOptions() {
			let filterOptions = {},
				years = {};

			this.contracts.forEach((c) => (years[1 * c.product__harvest] = true));
			years = Object.keys(years).sort();

			filterOptions.productYears = years.map(function (y) {
				return {
					label: y,
					value: y,
					checked: false,
				};
			});

			let tradedProductGrades = {};
			this.contracts.forEach(function (c) {
				if (c.product__grade.includes("WHEAT_B")) {
					tradedProductGrades["WHEAT_B"] = true;
				} else {
					tradedProductGrades[c.product__grade] = true;
				}
			});

			filterOptions.productGrades = [];
			Object.values(this.$cropOptions.productGradeOptions)
				.flat()
				.forEach((o) => {
					if (o.group && o.default) {
						filterOptions.productGrades.push({
							label: o.group,
							value: o.default,
						});
					} else if (o.group) {
					} else {
						filterOptions.productGrades.push({ label: o.name, value: o.id });
					}
				});

			filterOptions.productGrades = filterOptions.productGrades.filter(
				(option) => tradedProductGrades[option.value] === true
			);

			filterOptions.contractSources = [
				{ label: "cropspot", value: 1 },
				{ label: "External", value: 2 },
			];

			return filterOptions;
		},
		filteredContracts() {
			let f = this.filter,
				selectedType = this.filter.type,
				selectedGrades = f.productGrades,
				selectedHarvests = f.productYears,
				selectedContractSources = f.contractSources;

			return this.contracts
				.filter(
					(contract) =>
						selectedGrades.length == 0 ||
						(!contract.product__grade.includes("WHEAT_B") &&
							selectedGrades.includes(contract.product__grade)) ||
						(contract.product__grade.includes("WHEAT_B") &&
							selectedGrades.includes("WHEAT_B"))
				)
				.filter(
					(contract) =>
						selectedHarvests.length == 0 ||
						selectedHarvests.includes(contract.product__harvest)
				)
				.filter((contract) => selectedType == contract.trade)
				.filter(
					(contract) =>
						selectedContractSources.length == 0 ||
						selectedContractSources.includes(
							contract.is_external_contract ? 2 : 1
						)
				);
		},
		activeFilterCount() {
			return Object.values(this.filter).flat().length - 1; // it's -1 because the type filter is always active
		},
		logoUrl: () => window.baseUrl + "/images/cropspot-logo.svg",
	},
	methods: {
		/**
		 * Vertragsliste asynchron nachladen (Shell rendert sofort). Wird beim Mount und über
		 * den Bus-Event `content:load` (z.B. nach Anlegen eines externen Vertrags) ausgelöst.
		 */
		loadContent() {
			const requestId = ++this.contentRequestId;

			axios
				.get(this.$route("my_contracts.content"))
				.then((response) => {
					// Nur die Antwort des zuletzt gestarteten Requests anwenden.
					if (requestId !== this.contentRequestId) {
						return;
					}

					this.contracts = response.data.contracts ?? [];
					this.userLocations = response.data.userLocations ?? [];
					this.isDummyData = response.data.isDummyData ?? false;
				})
				.finally(() => {
					if (requestId === this.contentRequestId) {
						this.contentLoadingSpinner = false;
					}
				});
		},
		/**
		 * Liste + Kachel-Kennzahlen neu laden (z.B. nach Anlegen/Bearbeiten eines Vertrags).
		 */
		reload() {
			// Kachel-Kennzahlen zuerst anstoßen (kleiner, schneller Request; Kacheln stehen oben),
			// erst danach den schwereren Listen-Content.
			this.loadSummary();
			this.loadContent();
		},
		/**
		 * Serverseitig aggregierte Kachel-Kennzahlen laden (filter-aware). summaryVersion erzwingt
		 * über den :key den Chart-Neuaufbau in den Kacheln (Remount).
		 */
		loadSummary() {
			const requestId = ++this.summaryRequestId;

			axios
				.get(this.$route("my_contracts.summary"), { params: this.filterParams })
				.then((response) => {
					// Nur die Antwort des zuletzt gestarteten Requests anwenden — sonst
					// ueberschreibt eine spaeter eintreffende, aeltere Antwort den aktuellen Filter.
					if (requestId !== this.summaryRequestId) {
						return;
					}

					this.summary = response.data;
					this.summaryVersion++;
				})
				.finally(() => {
					if (requestId === this.summaryRequestId) {
						this.summaryLoading = false;
					}
				});
		},
		closeFilter() {
			this.showFilter = false;
		},
		closeThankyouModal() {
			this.showTestButtonThankYouModal = false;
		},
	},
};
</script>
